<template lang="pug">
  MainPage(:title="$t('mainPage')" :subtitle="$t('mainPageSubTitle')")
    v-row
      v-col.col-8
        Licenses
      v-col.col-4
        Profile.mb-6
        Payment.mb-6
</template>

<script>
export default {
  name: 'Dashboard',
  components: {
    MainPage: () => import('@/components/layout/MainPage.vue'),
    Licenses: () => import('@/components/Blocks/LicensesList.vue'),
    Profile: () => import('@/components/Blocks/Profile.vue'),
    Payment: () => import('@/components/Blocks/Payment/Info.vue')
  }
}
</script>

<style scoped>

</style>
